<template>
	<div
		:id="id"
		class="window window-view"
		:class="{ 'window-bg': option.bg && size != 'full', 'window-full alpha-no': size == 'full' }"
		status="false"
		@click.self.stop="hide"
	>
		<div class="body bgView taL" :class="getSizeClass(size)">
			<Loading ref="Loading"></Loading>
			<div class="head cb">
				<div class="tool fSub hover-f-main_E tra-fast_E">
					<slot name="headButton"></slot>
					<button class="close bgClose style-close hover-f-error" :title="$t('cmd153', ['关闭'])" type="button" @click.stop="hide">
						<Icon name="close" class="close-ico" />
					</button>
				</div>
				<slot name="head"></slot>
			</div>
			<slot name="tabPart"></slot>
			<section class="ms-diff ps-in-t">
				<slot></slot>
			</section>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";

export default {
	name: "WindowForView",
	props: {
		id: {
			//指定dom的id
			type: String,
			default: "",
		},
		bg: {
			//是否显示遮罩背景
			type: Boolean,
			default: false,
		},
		size: {
			//设定大小
			type: String,
			default: "l",
		},
	},
	components: {},
	created() {},
	data() {
		return {
			option: {
				bg: this.bg, //是否显示背景
			},
			lockTime: null, //短时间不再触发
		};
	},
	watch: {
		$route: function (nUrl, oUrl) {
			if (nUrl != oUrl) {
				this.hide();
			}
		},
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		getSizeClass: lib.getSizeClass,
		outClickToHide(e) {
			if (e) {
				if ($(e.target).parents(".amap-sug-result").length == 0) {
					//处理编辑电站时，因高德地图的应用在外部生成了dom，此时不关闭
					this.hide();
				}
			}
		},
		loadStatusAction: function (action) {
			if (action) this.$refs.Loading.show();
			else this.$refs.Loading.hide();
		},
		show: function (option) {
			this.lockTime = false;
			if (option) {
				if (option.bg != undefined) this.option.bg = option.bg;
				this.showEndDo(600, option.end);
			}
			setTimeout(() => {
				//加延时保证平滑出现
				$(document).off("click", this.outClickToHide);
				if ($(this.$el).find(".body-full").length == 0) {
					$(document).on("click", this.outClickToHide);
				}
				$(this.$el).find(".body").css("will-change", "transform");
				lib.windowCtrl($(this.$el), "true"); //,{end:option?option.end:undefined}
			}, 0);
		},
		showEndDo(delayMs, fn) {
			//确保动画完成再执行
			if (fn) {
				setTimeout(() => {
					if (
						Math.abs($(this.$el).find(".body").first().offset().left + $(this.$el).find(".body").innerWidth() - $(window).width()) <=
						$(window).width() * 0.1
					) {
						fn();
					} else {
						this.showEndDo(100, fn);
					}
				}, delayMs);
			}
		},
		hide: function () {
			if (this.lockTime == false) {
				$(document).off("click", this.outClickToHide);
				this.$emit("Close");
				lib.windowCtrl($(this.$el), "false");
				this.hideEndDo(600, () => {
					$(this.$el).find(".body").css("will-change", "");
					this.$emit("Closed");
				});
				this.lockTime = true;
			}
		},
		hideEndDo(delayMs, fn) {
			//确保动画完成再执行
			if (fn) {
				setTimeout(() => {
					if (Math.abs($(this.$el).find(".body").first().offset().left - $(window).width()) <= $(window).width() * 0.1) {
						fn();
					} else {
						this.hideEndDo(100, fn);
					}
				}, delayMs);
			}
		},
	},
	mounted() {
		if ($(this.$el).parents(".window-view").length) {
			//在详情内的固定使用背景遮罩
			this.option.bg = true;
		}
	},
};
</script>
<style lang="scss" scoped>
.window-view {
	> .body {
		padding: {
			bottom: 0;
		}
		top: $headHeight;
		right: 0;
		bottom: 0;
		background-color: $bgView;
		border-radius: 0;
		transform: rotateX(0) translateZ(0) translateX(100%);
		> .head {
			min-height: 4em;
			font-size: 1em;
			text-align: left;
			cursor: auto;
			user-select: auto;
			background-color: $contentBgColor;
			border-radius: 0;
			padding: {
				right: 2.5rem;
				left: 2.5rem;
			}
			.main {
				max-width: 15em;
				font-size: 1.4em;
				@extend %textCut;
			}
			.sub {
				max-width: 20em;
				@extend %textCut;
			}
			button {
				max-width: 6em;
				line-height: 1;
				margin: {
					left: $viewToolButtonSpace;
				}
			}
		}
		.close {
			margin: {
				top: 0;
			}
			position: static;
			padding: 0.5em;
			background-color: rgba($black, 0.06);
			border-radius: 50%;
			opacity: 1;
			fill: $error;
			&:hover {
				background-color: $error;
				fill: $white;
			}
		}
		//>*{height:unset;}
	}
	.bgPanel {
		background: $viewPanelBgColor;
		.bgLight {
			background-color: $viewPanelLightColor;
		}
	}
	.tool {
		position: absolute;
		right: 1em;
	}
	section {
		padding: {
			right: $space-in / 2;
			bottom: $space-in / 2;
			left: $space-in / 2;
		}
	}
}
.window-view.window-bg,
.window-full {
	.body {
		top: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/WindowForView.vue